import React from 'react';
import PropTypes from 'prop-types';
import withLocalization from '../higherOrderComponents/withLocalization';
import PageTop from '../layout/PageTop';

const allowedErrorCodes = [
  '401',
  '404',
  '500'
];

const Error = ({ code, translate }) => {
  const getTranslatedText = function (translationString) {
    return translate(`${code}/${translationString}`);
  };

  return (
    <React.Fragment>
      <PageTop
        documentTitle={getTranslatedText('document-title')}
        documentDescription={getTranslatedText('document-desc')}
        mainHeadingContent={getTranslatedText('main-heading')}
      />

      <p className='text-center'>{getTranslatedText('page-content')}</p>
    </React.Fragment>
  );
};

Error.propTypes = {
  code: PropTypes.oneOf(allowedErrorCodes).isRequired
};

export default withLocalization(Error, allowedErrorCodes.map(code => `pages/error/${code}`));